module.exports = __webpack_public_path__ + "img/IMG-20161206-WA0012.ae587c6f.jpg";